import { DownloadOutlined } from "@ant-design/icons";
import { List } from "antd";
import { type InstanceLogsTabProps } from "../redux/slices/midservice/midserviceTypes";
import React from "react";
import { getApiUrl } from "../utils/url";

export const LogsView = ({ logs }: InstanceLogsTabProps): JSX.Element => {
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={logs}
      renderItem={(item) => (
        <List.Item
          actions={[
            <a
              target="_blank"
              href={`${getApiUrl()}${item.archiveUrl}`}
              key="list-loadmore-edit"
              rel="noreferrer"
            >
              Скачать <DownloadOutlined />
            </a>,
          ]}
        >
          <List.Item.Meta
            title={
              <a
                target="_blank"
                href={`${getApiUrl()}${item.archiveUrl}`}
                key="list-loadmore-edit"
                rel="noreferrer"
              >
                {item.name}
              </a>
            }
          />
        </List.Item>
      )}
    />
  );
};
